import React, {useContext, useEffect, useState} from "react";
import {Link} from "react-router-dom";
import {Box, Grid, Typography} from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import Progress from "../../../components/progress/progress";
import Table from "../../../components/table/tableHistory";
import axiosClient from "../../../utils/axios-client";

import "./mySubscriptions.css";
import {
  useGetStripeSubscription,
  useGetSubscriptionDataForUpgradeToYearly,
  useHandleStripeSubscription,
} from "../../../graphql/graphql/stripe/hooks";
import {useRefData} from "../../../graphql/graphql/ref/hooks";
import RefCrediitTable from "../../dashboard/refCrediitTable";
import {useConfirm} from "material-ui-confirm";
import moment from "moment";
import {MenuContext} from "../../../contexts/menuContext";
import { createTheme, ThemeProvider } from '@mui/material/styles';

const subscriptions = [
  {
    plan: "year",
    price: 576,
    name: "Annually",
  },
  {
    plan: "month",
    price: 60,
    name: "Monthly",
  },
  {
    plan: "quarterly",
    price: 171,
    name: "Quarterly",
  },
];

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: "#0f0f0f"
    }
  },
});

const MySubscriptions = () => {
  const {isSmall} = useContext(MenuContext);
  const {data} = useRefData();
  const {updateSubscriptionToYearly} = useHandleStripeSubscription();
  const {subscription} = useGetStripeSubscription();
  //console.log("🚀 ~ file: mySubscriptions.jsx:68 ~ MySubscriptions ~ subscription:", subscription);
  const {getUpgradeData} = useGetSubscriptionDataForUpgradeToYearly();

  const confirm = useConfirm();
  // useEffect(() => {
  //   axiosClient
  //     .get("/user/stripe/subscription")
  //     .then(async ({data: {subscription}}) => {
  //       const {data} = await axiosClient.get("/user/referral/history");
  //       setreferralFullData(data);
  //       setSubscription(
  //         subscriptions.find((plan) => plan.price === subscription.price)
  //       );
  //     })
  //     .catch((err) => {
  //       setSubscription({});
  //     });
  // }, []);

  return (
    <ThemeProvider theme={darkTheme}>
      <Box className="subscriptionMain">
        <Typography variant="h4" className="setting_page_heading ">
          My Subscriptions
        </Typography>
        <Box className="content">
          <Box className="planSect custom-padding" mb={3}>
            <Box p={{xs: 2, sm: 3}}>
              <Box className="planHeader" mb={3}>
                <Box>
                  <Typography variant="h6" m={0} p={0}>
                    BTD PRO plan{" "}
                    {subscription && <span>{subscriptions.find(({plan}) => plan == subscription?.plan)?.name}</span>}
                  </Typography>
                  <Typography>Full membership access to buythedip.com.</Typography>
                </Box>
                <Box className="planAmt" display="flex" alignItems="baseline" gap={1}>
                  <Typography variant="h3" display="flex" alignItems="center">
                    $ <span>{subscription?.price}</span>
                  </Typography>
                  <Typography>per {subscription?.plan}</Typography>
                </Box>
              </Box>
              <Typography className="progressTitle">
                {data?.activeReferralCount >= 3 ? 3 : data?.activeReferralCount} of 3 referrals{" "}
                {3 - data?.activeReferralCount >= 0
                  ? isSmall
                    ? "(3 referrals = 100% off)"
                    : `(refer ${3 - data?.activeReferralCount} more friends for a free membership)`
                  : ""}
              </Typography>
              <Progress
                value={(data?.activeReferralCount * 100) / 3 > 100 ? 100 : (data?.activeReferralCount * 100) / 3}
              />
            </Box>
            {subscription?.plan !== "year" && (
              <Box className="upgradeSect" p={2}>
                <Link
                  to=""
                  onClick={async () => {
                    const {data} = await getUpgradeData();
                    //console.log(data);
                    const {defaultPaymentMethod, amount, nextBillingDate} = data.subscriptionDataForUpgradeToYearly;
                    confirm({
                      title: <span className="text-white text-lg">Are you sure you want to upgrade to yearly plan?</span>,
                      description: (
                        <span className="text-white text-opacity-60	 text-sm">
                          {` Your default payment method *${defaultPaymentMethod} will be 
                              charged a prorated amount of $${amount} immediately. 
                              Your next billing cycle will be ${
                                moment().add(1, "years").format("MMMM Do, YYYY")}.`}
                        </span>
                      ),
                      confirmationText: "Confirm",
                      cancellationText: "Cancel",
                      confirmationButtonProps: {
                        style: {
                          backgroundColor: "#eda044",
                          color: "#000",
                       
                        }
                      },
                    }).then(() => updateSubscriptionToYearly());
                  }}
                >
                  Upgrade to yearly, save $120 <ArrowOutwardIcon />
                </Link>
              </Box>
            )}
          </Box>
          <Box className="creditSect" py={3} mb={3}>
            <Typography className="custom-padding" variant="h5">
              Subscription Credit
            </Typography>
            <Typography mb="24px">
              When you have referrals active, your referrals with show up here as credits. So, if you have 1 referral
              active, that will save you $20.00 and it will show up as a $20.00 credit.
            </Typography>

            <RefCrediitTable
              className="custom-padding"
              title="Credits History"
              desc="Credits are applied automatically so that you pay as low as possible."
            />
          </Box>
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default MySubscriptions;
